import type { Normalizer } from '../format'

export class WhitespaceNormalizer implements Normalizer {
  matches(input: string) {
    return /\s/.test(input)
  }

  normalize(input: string) {
    return input.split(' ').map((part) => part.trim().toLowerCase())
  }
}
